import { render, staticRenderFns } from "./FaceDetection.vue?vue&type=template&id=52837af4&scoped=true&"
import script from "./FaceDetection.vue?vue&type=script&lang=js&"
export * from "./FaceDetection.vue?vue&type=script&lang=js&"
import style0 from "./FaceDetection.vue?vue&type=style&index=0&id=52837af4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52837af4",
  null
  
)

export default component.exports